import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceipts = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#a4a7e4",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Receipts",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M13.2 15V1.93333C13.2 1.6858 13.1017 1.4484 12.9267 1.27337C12.7516 1.09833 12.5142 1 12.2667 1H2.93333C2.6858 1 2.4484 1.09833 2.27337 1.27337C2.09834 1.4484 2 1.6858 2 1.93333V15L3.86667 13.1333L5.73333 15L7.6 13.1333L9.46667 15L11.3333 13.1333L13.2 15Z",
					fill: "currentColor",
					fillOpacity: .25,
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M6.16074 8.99364C6.33125 9.21792 6.55338 9.39771 6.80827 9.51774C7.06315 9.63778 7.34324 9.6945 7.62475 9.68309C8.52222 9.68309 9.25028 9.13705 9.25028 8.46414C9.25028 7.79124 8.52222 7.24519 7.62475 7.24519C6.72727 7.24519 6 6.69915 6 6.02545C6 5.35176 6.72727 4.8065 7.62475 4.8065C7.90622 4.79529 8.18625 4.8521 8.4411 4.97212C8.69595 5.09214 8.91811 5.27183 9.08875 5.49595",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M7.625 9.68762V10.5",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M7.625 4V4.81158",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})
	})
});
export default SvgReceipts;
